<template>

 <div>
    <div class="designer_head">
       <span class="head_title">{{ HeadTitle }}</span>
       <div class="head_count">{{ ordersCount }}</div>
       <div class="button_region">
            <div class="add_order toggle_button" @click="toggleOrders">
                <img src="./assets/down_arrow.png" v-if="ordersVisible">
                <img src="./assets/right_arrow.png" v-if="!ordersVisible">
            </div>
       </div>
    </div>
    <q-infinite-scroll :handler="loadMore" :offset=50>
            
            <div class="ordersContainer q-pa-xs" v-if="ordersVisible" v-bind:class="{'q-pa-sm' : $q.screen.gt.sm}">
                    <main-order-line v-for="(order) in check_orders" 
                        :key="'readyOrders'+order.id" 
                        :order="order" 
                        :index='order.id'/>
            </div>

        <div class="row justify-center" style="margin-bottom: 50px; z-index:50" v-if="showLoading">
            <q-spinner-dots slot="message" :size="80" />
        </div>

    </q-infinite-scroll>

 </div>

</template>

<script>
/* eslint-disable */

import MainOrderLine from './MainOrderLine'
import { setTimeout } from 'timers';


export default {
    name : 'readyOrders',

    components : {
        MainOrderLine,
    },

    data () {
        return {
            HeadTitle: 'Готово',
            ordersVisible : true,
            showLoading : true,
        }
    },

    
    computed: {

      check_orders() {
           return this.$store.getters.readyOrders.sort(function(a,b) {
               if (a.id > b.id) return -1;
               if (a.id < b.id) return 1;
               if (a.id == b.id) return 0;
           });
      },
      
       ordersCount() {
          return this.$store.getters.readyOrders.length;
      }
    },
    
    methods : {
        toggleOrders() {
            this.ordersVisible = !this.ordersVisible;
        },

        async loadMore(index, done) {
            try {
                if (this.$store.getters.allOrders.length > 0) { // отсекаем первоначальную загрузку
                    await this.$store.dispatch('retrieveOrders')
                    .then((result) => {
                        done();
                    })
                    .catch((error)=> {
                        this.showLoading = false;
                    });
                } else {
                    //ставим на ожидание 2 сек и запускаем повторную проверку
                    setTimeout(()=>{
                        done();
                    }, 2000)
                }
            } catch {}

        }

    }

}
</script>

<style lang="scss" scoped>

@import url("https://cdn.jsdelivr.net/npm/animate.css@3.5.2/animate.min.css");

.designer_head {
        display: flex;
        align-items: center;
        animation-duration: 0.3s;
        height : 45px;
        background: rgb(136, 1, 163);
        padding-left : 15px;

    .head_title {
        font-size:18px;
        color : white;
        padding-top : 15px;
        text-transform: uppercase; 
        white-space:  nowrap;
    }
    .head_count {
        margin-left:20px;
        color : white;
        background : rgb(157, 4, 218);
        min-width : 60px;
        height : 45px;
        font-size: 28px;
        font-weight: bold;
        padding-left: 10px;
        padding-right: 10px;
        padding-top : 8px;
        text-align: center;
    }
    .add_order {
        width : 80px;
        height : 45px;
        text-align: center;
        font-size: 40px;
        cursor: pointer;
        &:hover {
            background : rgb(183, 52, 235);
            color : rgb(4, 134, 4);
        }
    }
    .button_region {
        width : 100%;
        display : flex;
        justify-content : flex-end;
        
    }
}
.ordersContainer{
    border : 1px solid rgb(182, 182, 182);
    border-top : 0px;
    width : 100%;
    // height : 300px;
    animation-duration: 1s;
}





</style>

